import {
    Box,
    Container,
    InputLabel,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@material-ui/core";
import { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import Config from "Config";
import moment from "moment-timezone";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { send } from "../../SendRequest";
import { isEmpty } from "../../Utils";
import CustomDatePicker from "../CustomDatePicker/CustomDatePicker";
import Header from "../Header/Header";
import PortalNavbar from "../PortalNavbar/PortalNavbar";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#6b5b9a",
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

function MonthlySubmissionReport() {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const [res, setRes] = useState(null);
    const { control, getValues, setValue } = useForm({});
    const onSubmit = () => {
        let data = { ...getValues() };
        let from = isEmpty(getValues("from"))
            ? null
            : moment(getValues("from"));
        data[`from`] = isEmpty(from) ? null : from.format("YYYY-MM-DD");
        data[`to`] = isEmpty(from)
            ? null
            : from.endOf("month").format("YYYY-MM-DD");
        const option = {
            url: `${Config.CONTENT_PATH}/workflow/getMonthlyReport`,
            method: "POST",
            body: JSON.stringify(data),
        };
        dispatch(send("MONTHLY_SUBMISSION_REPORT", option))
            .then((response) => response.json())
            .then((response) => setRes(response));
    };

    const intToEDB = (formId) => {
        let EDBFormId = formId;
        switch (formId) {
            case 96:
                EDBFormId = "96 - EDB98 (EDB113)";
                break;
            case 97:
                EDBFormId = "97 - EDB96";
                break;
            case 98:
                EDBFormId = "98 - EDB97";
                break;

            default:
                break;
        }
        return EDBFormId;
    };

    return (
        <Container maxWidth="md">
            <Header
                headerTitle={t("common.sideNavList.MonthlySubmissionReport")}
                className="header"
            />
            <Box className="container">
                <PortalNavbar aside className="drawer" />
                <main className="main">
                    <Box style={{ marginLeft: "15px" }}>
                        <Box
                            marginTop={3}
                            padding={5}
                            border={2}
                            borderRadius={2}
                            borderColor="rgba(61, 59, 59, 0.5)"
                        >
                            <Typography style={{ fontSize: "16px" }}>
                                {t("common.portal.selectMonth")}
                            </Typography>
                            <Box display="flex" padding={2}>
                                <InputLabel
                                    htmlFor="From"
                                    style={{
                                        alignSelf: "center",
                                    }}
                                >
                                    <Typography style={{ fontSize: "16px" }}>
                                        {t("common.portal.month")}
                                        {t("common.colon")}
                                    </Typography>
                                </InputLabel>
                                <Box padding={5}>
                                    <CustomDatePicker
                                        control={control}
                                        name="from"
                                        type="month"
                                        maxDate={new Date()}
                                        onChange={onSubmit}
                                    />
                                </Box>
                            </Box>
                        </Box>
                        {res && res.length > 0 ? (
                            <Box marginTop={5}>
                                <TableContainer
                                    component={Paper}
                                    style={{ maxHeight: 600 }}
                                >
                                    <Table
                                        stickyHeader
                                        size="small"
                                        aria-label="monthly-report"
                                    >
                                        <TableHead stickyHeader>
                                            <TableRow>
                                                <StyledTableCell align="center">
                                                    <b>
                                                        {t(
                                                            "common.portal.formId"
                                                        )}
                                                    </b>
                                                </StyledTableCell>
                                                <StyledTableCell
                                                    align="center"
                                                >
                                                    <b>
                                                        {t(
                                                            "common.portal.amount"
                                                        )}
                                                    </b>
                                                </StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {res.map((row) => (
                                                <StyledTableRow
                                                    key={row.formid}
                                                >
                                                    <StyledTableCell
                                                        component="th"
                                                        scope="row"
                                                        align="center"
                                                    >
                                                        {intToEDB(row.formid)}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="center">
                                                        {row.submission}
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            ))}
                                            {res.length > 0 && (
                                                <StyledTableRow>
                                                    <StyledTableCell
                                                        component="th"
                                                        scope="row"
                                                        align="center"
                                                    >
                                                        <b>{t("common.portal.total")}</b>
                                                    </StyledTableCell>
                                                    <StyledTableCell align="center">
                                                        <b>{res?.reduce(
                                                            (total, row) =>
                                                                total +
                                                                Number(
                                                                    row?.submission
                                                                ),
                                                            0
                                                        )}</b>
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                        ) : (
                            <Box style={{}}>
                                <Typography style={{ fontSize: "16px" }}>
                                    {t("common.delegation.emptyResult")}
                                </Typography>
                            </Box>
                        )}
                    </Box>
                </main>
            </Box>
        </Container>
    );
}

export default MonthlySubmissionReport;
